<template>
  <v-container class="py-12">
    <v-row justify="center">
      <v-col
        xl="4"
        style="max-width: 450px;"
      >
        <div class="text-center mb-10">
          <img
            src="@/assets/img/logo.svg"
            width="160px"
            alt="Ultrax Logo"
          >
        </div>
        <v-card
          color="white"
          class="pa-8 elevation-10"
          rounded="lg"
        >
          <form @submit.prevent="submit()">
            <div class="text-h5 text-center mb-8">
              Sign up for Ultrax Drill Builder
            </div>
            <div v-if="success">
              <v-alert type="success">
                Thank you. Please check your email to finish your signup!
              </v-alert>
            </div>
            <div v-else>
              <validation-observer ref="validation">
                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  name="E-mail"
                >
                  <v-text-field
                    v-model="form.organisation"
                    label="Club Name"
                    :error-messages="errors"
                    outlined
                    autocomplete="username"
                  />
                </validation-provider>
                <v-row dense>
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      rules="required"
                      name="E-mail"
                    >
                      <v-text-field
                        v-model="form.firstName"
                        label="Your First Name"
                        :error-messages="errors"
                        outlined
                      />
                    </validation-provider>
                  </v-col>
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      rules="required"
                      name="E-mail"
                    >
                      <v-text-field
                        v-model="form.lastName"
                        label="Your Last Name"
                        :error-messages="errors"
                        outlined
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <validation-provider
                  v-slot="{ errors }"
                  rules="required|email|unique_email"
                  name="E-mail"
                >
                  <v-text-field
                    v-model="form.email"
                    label="E-mail"
                    :error-messages="errors"
                    outlined
                    autocomplete="username"
                  />
                </validation-provider>
              </validation-observer>

              <v-btn
                block
                x-large
                type="submit"
                color="primary"
                class="ma-0 text-none"
                :loading="submitting"
              >
                Submit
              </v-btn>
            </div>
          </form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { UserApiService } from '@/data/services/UserApiService'

export default {
    data() {
      return {
        form: {
          email: '',
          firstName: '',
          lastName: '',
          organisation: ''
        },
        submitting: false,
        success: false
      }
    },
    methods: {
      async submit() {
        if (!(await this.$refs.validation.validate())) {
          return
        }

        await this.login()
      },
      async login() {
        try {
          this.submitting = true

           await UserApiService.signup({
            organisation: this.form.organisation,
            first_name: this.form.firstName,
            last_name: this.form.lastName,
            email: this.form.email
          })

          this.success = true
        } catch (e) {
          this.$store.dispatch(this.$storeActions.ALERT, {
            text: this.$t('alert.something_wrong.error'),
            color: 'error'
          })

          throw e
        } finally {
          this.submitting = false
        }
      }
    }
  }
</script>
